import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { AudienciaDto } from '@models/audiencia/audienciaDto.model';
import { CreateAudienciaRequest } from '@models/audiencia/createAudienciaRequest.model';
import { UpdateAudienciaRequest } from '@models/audiencia/updateAudienciaRequest.model';
import { BaseDto } from '@models/base/baseDto.model';
import { AccionesDialog } from '@models/base/identificadores.model';
import { ExpedienteSummaryDto } from '@models/expediente/expedienteSummary.model';
import { AudienciaService } from '@services/audiencia/audiencia.service';
import { EstadoAudienciaService } from '@services/estadoAudiencia/estadoAudiencia.service';
import { LoginService } from '@services/login/login.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TipoAudienciaService } from '@services/tipoAudiencia/tipoAudiencia.service';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { BuscarPersonaComponent } from '@views/busquedas/buscar-persona/buscar-persona.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ButtonAddComponent } from 'src/app/component/button-add/button-add.component';
import { ButtonCancelDialogComponent } from 'src/app/component/button-cancel-dialog/button-cancel-dialog.component';
import { ButtonCloseDialogComponent } from 'src/app/component/button-close-dialog/button-close-dialog.component';
import { ButtonCloseComponent } from 'src/app/component/button-close/button-close.component';
import { ButtonDeleteAndCancelComponent } from 'src/app/component/button-delete-and-cancel/button-delete-and-cancel.component';
import { ButtonDeleteComponent } from 'src/app/component/button-delete/button-delete.component';
import { ButtonSaveComponent } from 'src/app/component/button-save/button-save.component';
import { GoBackAndTitleComponent } from 'src/app/component/go-back-and-title/go-back-and-title.component';

@Component({
  selector: 'app-dialog-form',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, ButtonCloseDialogComponent, A11yModule, CommonModule, MatExpansionModule, ButtonSaveComponent, ButtonDeleteAndCancelComponent, ButtonCloseComponent, MatFormFieldModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule, MatInputModule, CommonModule, FormsModule, MatSortModule, ReactiveFormsModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, BuscarExpedienteComponent, MatTabsModule, ButtonCloseDialogComponent, ButtonCancelDialogComponent, ButtonAddComponent, MatCheckboxModule,ButtonDeleteComponent],
  templateUrl: './dialog-form-auditoria.component.html',
  styleUrl: './dialog-form-auditoria.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DialogFormAuditoriaComponent {
  estadosAudiencia!: BaseDto[];
  expedienteDto!: ExpedienteSummaryDto;

  get f() { return this.form.controls; }
  accionesDialog = AccionesDialog;
  form!: FormGroup;
  localData: any;
  formBuilder: FormBuilder = new FormBuilder;
  tiposAudiencia!: BaseDto[];
  audienciaDto!: AudienciaDto;

  constructor(
    public dialogRef: MatDialogRef<DialogFormAuditoriaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private tipoAudienciaService: TipoAudienciaService,
    private estadoAudienciaService: EstadoAudienciaService,
    private audienciaService: AudienciaService,
    private router: Router,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService,
  ) {

    this.getAllTiposAudiencia();
    this.getAllEstadosAudiencia();
  }

  ngOnInit(): void {
    const audiencia = this.data?.audiencia || {};

    this.form = this.formBuilder.group({
      Descripcion: [audiencia.descripcion || '', Validators.compose([Validators.maxLength(100)])],
      Id: [audiencia.id || ''],
      Observaciones: [audiencia.observaciones || ''],
      RequiereActa: [audiencia.requiereActa || false],
      ActaGenerada: [audiencia.actaGenerada || false],
      ActaUrl: [audiencia.actaUrl || ''],
      LinkVirtual: [audiencia.linkVirtual || ''],
      Notificado: [audiencia.notificado || false],
      ResultadoAudiencia: [audiencia.resultadoAudiencia || ''],
      Lugar: [audiencia.lugar || '', Validators.compose([Validators.required, Validators.maxLength(200)])],
      IdTipoAudiencia: [audiencia.tipoAudiencia?.id || '', Validators.compose([Validators.required])],
      IdEstadoAudiencia: [audiencia.estadoAudiencia?.id || '', Validators.compose([Validators.required])],
      Sala: [audiencia.sala || '', Validators.compose([Validators.maxLength(200)])],
      Fecha: [audiencia.fecha || '', Validators.compose([Validators.required, Validators.maxLength(50)])],
      IdExpediente: [audiencia.expediente?.id || null, Validators.compose([Validators.required])],

    });
  }


  selectExpediente($event: any) {
    this.expedienteDto = $event
    this.form.controls['IdExpediente'].setValue(this.expedienteDto.id)
  }

  cancelar() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar, data: this.data });
  }

  getAllTiposAudiencia() {
    this.spinner.show("spTiposAudiencia")
    this.tipoAudienciaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spTiposAudiencia")
          this.tiposAudiencia = data
        },
        error => {
          this.spinner.hide("spTiposAudiencia")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllEstadosAudiencia() {
    this.spinner.show("spEstadosAudiencia")
    this.estadoAudienciaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spEstadosAudiencia")
          this.estadosAudiencia = data
        },
        error => {
          this.spinner.hide("spEstadosAudiencia")
          this.snackBar.showError(error, "Error");
        })
  }

  agregar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.spinner.show("spAudiencia")
    this.audienciaService.create(this.setCreateAudienciaRequest())
      .subscribe(
        data => {
          this.spinner.hide("spAudiencia")
          this.snackBar.showSuccess('Registro creado con correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Agregar, data: this.data.audiencia, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spAudiencia")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  modificar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.spinner.show("spAudiencia")
    this.audienciaService.update(this.setUpdateAudienciaRequest())
      .subscribe(
        data => {
          this.spinner.hide("spAudiencia")
          this.snackBar.showSuccess('Registro modificado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Modificar, data: this.data.audiencia, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spAudiencia")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  eliminar() {
    this.spinner.show("spAudiencia")
    this.audienciaService.delete(this.data.audiencia.id)
      .subscribe(
        data => {
          this.spinner.hide("spAudiencia")
          this.snackBar.showSuccess('Registro eliminado correctamente.', "Exito");
          this.dialogRef.close({ event: AccionesDialog.Eliminar, data: this.data.audiencia, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spAudiencia")
          this.snackBar.showError(error, "Error");
          this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  setCreateAudienciaRequest(): CreateAudienciaRequest {

    const createAudienciaRequest = new CreateAudienciaRequest();

    createAudienciaRequest.sala = this.form.controls['Sala'].value;
    createAudienciaRequest.lugar = this.form.controls['Lugar'].value;
    createAudienciaRequest.fecha = this.form.controls['Fecha'].value == "" ? null : this.form.controls['Fecha'].value;
    createAudienciaRequest.descripcion = this.form.controls['Descripcion'].value;
    createAudienciaRequest.observaciones = this.form.controls['Observaciones'].value;
    createAudienciaRequest.idTipoAudiencia = this.form.controls['IdTipoAudiencia'].value == "" ? null : this.form.controls['IdTipoAudiencia'].value;
    createAudienciaRequest.idEstadoAudiencia = this.form.controls['IdEstadoAudiencia'].value == "" ? null : this.form.controls['IdEstadoAudiencia'].value;
    createAudienciaRequest.requiereActa = this.form.controls['RequiereActa'].value == "" ? null : this.form.controls['RequiereActa'].value;
    createAudienciaRequest.actaGenerada = this.form.controls['ActaGenerada'].value == "" ? null : this.form.controls['ActaGenerada'].value;
    createAudienciaRequest.actaUrl = this.form.controls['ActaUrl'].value == "" ? null : this.form.controls['ActaUrl'].value;
    createAudienciaRequest.linkVirtual = this.form.controls['LinkVirtual'].value == "" ? null : this.form.controls['LinkVirtual'].value;
    createAudienciaRequest.notificado = this.form.controls['Notificado'].value == "" ? null : this.form.controls['Notificado'].value;
    createAudienciaRequest.resultadoAudiencia = this.form.controls['ResultadoAudiencia'].value == "" ? null : this.form.controls['ResultadoAudiencia'].value;
    createAudienciaRequest.idExpediente = this.expedienteDto.id
    createAudienciaRequest.asignadoA = this.loginService.getIdUser();

    return createAudienciaRequest
  }

  setUpdateAudienciaRequest(): UpdateAudienciaRequest {

    const updateAudienciaRequest = new UpdateAudienciaRequest();
updateAudienciaRequest.id = this.form.controls['Id'].value;
    updateAudienciaRequest.sala = this.form.controls['Sala'].value;
    updateAudienciaRequest.lugar = this.form.controls['Lugar'].value;
    updateAudienciaRequest.fecha = this.form.controls['Fecha'].value == "" ? null : this.form.controls['Fecha'].value;
    updateAudienciaRequest.descripcion = this.form.controls['Descripcion'].value;
    updateAudienciaRequest.observaciones = this.form.controls['Observaciones'].value;
    updateAudienciaRequest.idTipoAudiencia = this.form.controls['IdTipoAudiencia'].value == "" ? null : this.form.controls['IdTipoAudiencia'].value;
    updateAudienciaRequest.idEstadoAudiencia = this.form.controls['IdEstadoAudiencia'].value == "" ? null : this.form.controls['IdEstadoAudiencia'].value;
    updateAudienciaRequest.requiereActa = this.form.controls['RequiereActa'].value == "" ? null : this.form.controls['RequiereActa'].value;
    updateAudienciaRequest.actaGenerada = this.form.controls['ActaGenerada'].value == "" ? null : this.form.controls['ActaGenerada'].value;
    updateAudienciaRequest.actaUrl = this.form.controls['ActaUrl'].value == "" ? null : this.form.controls['ActaUrl'].value;
    updateAudienciaRequest.linkVirtual = this.form.controls['LinkVirtual'].value == "" ? null : this.form.controls['LinkVirtual'].value;
    updateAudienciaRequest.notificado = this.form.controls['Notificado'].value == "" ? null : this.form.controls['Notificado'].value;
    updateAudienciaRequest.resultadoAudiencia = this.form.controls['ResultadoAudiencia'].value == "" ? null : this.form.controls['ResultadoAudiencia'].value;
    updateAudienciaRequest.idExpediente = this.form.controls['IdExpediente'].value == "" ? null : this.form.controls['IdExpediente'].value;
    updateAudienciaRequest.asignadoA = this.loginService.getIdUser();

    return updateAudienciaRequest
  }

  onReset() {
    this.form.reset();
  }

  trackByaudiencias(index: number, audiencia: any): any { return audiencia; }



  async getAudienciaById(id: number) {
    this.spinner.show("spView")
    await this.audienciaService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide("spView")
          this.audienciaDto = data
        },
        error => {
          this.spinner.hide("spView")
          this.snackBar.showError(error, "Error");
        })
  }

  esUrlValida(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  }

  abrirUrl(url: string): void {
    if (this.esUrlValida(url)) {
      window.open(url, '_blank');
    }
  }
}
